export const breakpoints = {
  mobile: 0,
  tablet: 768,
  computer: 1024,
}
